// src/components/WhyChooseUs/WhyChooseUs.js
import React from "react";
import { FaStar, FaShippingFast, FaRegHandshake, FaShieldAlt } from "react-icons/fa"; // Import icons
import "./WhyChooseUs.css";

const whyChooseUsData = [
  { icon: <FaStar />, title: "Premium Quality", description: "We provide high-quality, durable furniture for global export." },
  { icon: <FaShippingFast />, title: "Fast & Reliable", description: "Our efficient logistics ensure timely and secure delivery worldwide." },
  { icon: <FaRegHandshake />, title: "Trusted Partners", description: "We collaborate with top distributors to ensure seamless exports." },
  { icon: <FaShieldAlt />, title: "Secure Transactions", description: "Your orders are handled with utmost security and compliance." },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us">
      <h2>Why Choose Us?</h2>
      <p className="why-choose-description">
        We prioritize quality, efficiency, and trust to provide seamless global exporting solutions.
      </p>
      <div className="why-choose-grid">
        {whyChooseUsData.map((item, index) => (
          <div key={index} className="why-choose-card">
            <div className="why-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
